export class PnPHelpers {
    public static setExtraLeft(element: HTMLElement) {
        if (!element) {return;}

        let extraLeft = 0;
        const parent = element.parentElement;
        const drawingToolIcon = parent?.querySelector<HTMLElement>('.highcharts-stocktools-wrapper');

        const isBottom = element.style.top && element.style.top.indexOf('calc(100%') > -1;
        if (drawingToolIcon?.classList.contains('show')) {
            const height = drawingToolIcon.clientHeight - 40;
            if (element.containClass('level1')) {
                const toolDiv = drawingToolIcon?.querySelector<HTMLElement>('.highcharts-stocktools-toolbar');
                const isOverlapped = toolDiv.clientHeight + element.clientHeight > height;
                if (!isBottom || isOverlapped) {
                    extraLeft = 52;
                }
            } 
            
            if (element.containClass('level2')) {
                const toolDiv = drawingToolIcon?.querySelector<HTMLElement>('li.highcharts-current > ul.highcharts-submenu-wrapper');
                const isOverlapped = toolDiv.clientHeight + element.clientHeight > height;
                if (!isBottom || isOverlapped) {
                    extraLeft = 92;
                }
            }
        }

        element.style.left = extraLeft + 'px';
    }
}